import { z } from 'zod';

// Client-side request schema (subset of server spec)
export const FeedbackRequestSchema = z.object({
  message: z
    .string()
    .min(1, 'Message is required')
    .max(4000, 'Message must be at most 4000 characters'),
  subject: z
    .string()
    .max(200, 'Subject must be at most 200 characters')
    .optional(),
  category: z
    .enum(['bug', 'feature', 'support', 'content', 'other'])
    .optional(),
  email: z
    .string()
    .min(1, 'Email is required so we can respond to you')
    .email('Please enter a valid email')
    .max(254, 'Email is too long'),
});

export type FeedbackRequest = z.infer<typeof FeedbackRequestSchema>;

export const FeedbackResponseSchema = z.object({
  success: z.boolean(),
  feedbackId: z.string(),
  queuedEmail: z.boolean().optional(),
  warning: z.string().optional(),
});

export type FeedbackResponse = z.infer<typeof FeedbackResponseSchema>;


